export const rootRoute = () => '/'
export const subjectsListRoute = () => '/patients'
export const subjectsNotInTreatmentListRoute = () => '/inactive-patients'
export const physiciansListRoute = () => '/physicians'
export const techniciansListRoute = () => '/technicians'
export const loginRoute = () => '/login'
export const logoutRoute = () => '/logout'
export const accountRoute = () => '/account'
export const registerRoute = () => '/register'
export const registerConfirmationRoute = () => '/register-confirm'
export const forgotPasswordRoute = () => '/forgot-password'
export const subjectShowRoute = (subjectIdentifier: string = ':subjectIdentifier') => `/subjects/${subjectIdentifier}`
export const reviewerShowRoute = (npi: string = ':npi') => `/physicians/${npi}`
export const createAccountRoute = (registrationCode: string = ':registrationCode') => `/create-account/${registrationCode}`
export const publicSiteRoute = () => 'https://luminopia.com/professional'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/routes.ts